import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './styles/design-tokens.css';
import './styles/tooltips.css';
import './styles/scrollbars.css';
import './styles/badges.css';
import './styles/typography.css';
import './styles/focus.css';
import './styles/cards.css';
import './styles/spacing.css';
import './styles/gradients.css';
import './index.css';
import App from './App';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
  });
}

// Disable browser scroll restoration so AppContent's scrollTo(0,0) on route
// change isn't overridden by the browser restoring a prior position — on
// mobile this caused post-login redirect to land slightly scrolled down.
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function SentryFallback({ resetError }) {
  return (
    <div style={{ padding: '2rem', textAlign: 'center', fontFamily: 'system-ui, sans-serif' }}>
      <h1 style={{ marginBottom: '0.5rem' }}>Something went wrong.</h1>
      <p style={{ color: '#555', marginBottom: '1rem' }}>
        We've been notified and are looking into it.
      </p>
      <button
        onClick={resetError}
        style={{
          padding: '0.5rem 1rem',
          borderRadius: 6,
          border: '1px solid #333',
          background: '#fff',
          cursor: 'pointer',
        }}
      >
        Try again
      </button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);


